<div class="flex w-[400px] flex-col gap-2">
  <elcia-search [control]="searchControl"/>

  <div class="flex gap-2">
    @for (completion of completionOptions; track completion) {
      <elcia-badge (click)="toggleCompletion(completion)"
                   [tone]="isCompletionSelected(completion) ? 'info' : 'neutral'"
                   class="cursor-pointer select-none">
        {{ 'todo-completion.' + completion | translate }}
      </elcia-badge>
    }
  </div>

  <div class="flex flex-col gap-2 max-h-80 overflow-y-auto pr-1">
    @for (todo of todos(); track todo.id) {
      <elcia-todo-picker-item (onTodoSelect)="this.onTodoSelect.emit($event)" [control]="control()" [todo]="todo"/>

    } @empty {
      <p class="text-sm text-[var(--p-gray-500)] text-center py-4">Aucun todo</p>
    }
  </div>
</div>
